<template>
    <div class="suppo-ord-page ve-list-page">
        <div class="suppo-ord-toolbar">
            <div style="margin-left:4px;font-size:12px;min-width:70px;flex-shrink:0;font-weight:600;white-space:nowrap;">{{ $LANG('0681', '字段查询') }} </div>
            <el-select v-model="selparam" :placeholder="$LANG('1675', '请选择列名')" filterable size="small" style="width:120px;margin-left:2px;">
                <span v-for="item in tabArr" :key='item.key'>
                    <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:300px; height:30px; ">
                <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
            </el-input>
            <div style=" font-size:12px;margin-left:5px;display:flex;width:120px">
                <div style="font-size:12px;margin-right:4px;color:red;white-space:nowrap;">{{ $LANG('0358', '状态') }}</div>
                <el-select @change="qryTabData" v-model="stfg_" size="small" style="width:90px">
                    <el-option :label="$LANG('0040', '所有记录')" value="ALL"></el-option>
                    <el-option :label="$LANG('1995', '待确认')" value="N"></el-option>
                    <el-option :label="$LANG('1982', '已确认')" value="Y"></el-option>
 
                </el-select> 
            </div>
            <div style="width:110px; line-height:30px;margin-left:5px" >                
                <el-button size="mini"  @click="nextGen" type="danger" icon="iconfont icon-xiashuangjiantou"><span style="font-size:12px;white-space:nowrap;">{{ $LANG('1047', '下推送货单') }} </span></el-button>
            </div>
            <div style="width:150px;flex-shrink:0;line-height:30px;margin-left:25px" >
                <el-button size="mini"  @click="downFile" type="primary" icon="iconfont icon-xiazai"><span style="font-size:12px;white-space:nowrap;">{{ $LANG('0231', '下载合同执行条款') }}</span> </el-button>
            </div>
            <div style="margin-left:15px;display:flex;align-items:center;flex-shrink:0;line-height:30px;">
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin-right:4px"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false">
                    <span style="font-size:12px">{{ $LANG('0683', '字段设置') }}</span>
                </el-link>
            </div>
        </div>
        <div class="ve-list-page__table">
        <ve-table :columns="vueCol"
            :table-data="tabData"
            :columnHiddenOption="columnHiddenOption"
            :footer-data="[]"
            :border-around="true"
            :border-x="true"
            :border-y="true"
            :fixed-header="true"
            row-key-field-name="IDSEQ"
            :row-style-option="rowStyleOption"
            :cell-style-option="cellStyleOption"
            :event-custom-option="eventCustomOption"
            :max-height="tabHeight"
            :virtual-scroll-option="virtualScrollOption"
            :scroll-width="0"
            :column-width-resize-option="columnWidthResizeOption"
            :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
            :cellSelectionOption="{enable: false}"
            v-loading="v_loading"
            :element-loading-text="$LANG('1959', '加载中')"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            id="suppo_ord_table"
            ref="tabref">
        </ve-table>
        </div>
        <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px" class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">{{ $LANG('0349', '每页') }}</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">{{ $LANG('0398', '跳至') }}</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">{{ $LANG('1660', '页') }}</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="drawer" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <span v-for="(gpitem,gpind) in formArr" :key="gpind"  >   
                    <div class="one-toolbar">
                    <span class="spanRow"> {{gpitem.gpnm}} </span>
                    </div>        
                    <Form :model="mainRow" :label-width="120" ref="supForm"  label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem  :label="$translate.getColTitle(item, $store.state.lang)"  :class=" 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">
                                <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.EDCSS==='date'" v-model="mainRow[item.FLDNO]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-input-number size="medium" :precision="item.DOTNUM" :disabled="saveFlag"  v-else-if="item.EDCSS==='number'" v-model="mainRow[item.FLDNO]" style="width:100%" ></el-input-number>   
                                <el-checkbox size="medium" border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="mainRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                <el-select size="medium" :disabled="saveFlag" v-else-if="item.EDCSS==='select'" v-model="mainRow[item.FLDNO]"   style="width:100%">
                                    <el-option v-for="(item,index) in comboArr[item.FLDNO]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                </el-select>
                                <el-select size="medium" :disabled="saveFlag" v-else-if="item.FLDNO==='ACTNO'" v-model="mainRow[item.FLDNO]"   style="width:100%">
                                    <el-option v-for="(item,index) in cashArr " :key="index" :label="item.ACCNM" :value="item.ACCNM"></el-option>
                                </el-select>
                                <el-select size="medium" filterable v-else-if="item.key==='SUPNO'" :disabled="saveFlag" style="width:100%" v-model="mainRow[item.FLDNO]">
                                    <el-row v-for="item in supArr " :key="item.IDNO">
                                        <el-col :span="6">
                                            <el-option  :label="item.IDNO" :value="item.IDSEQ"></el-option>
                                        </el-col>
                                        <el-col :span="6">
                                            <el-option  :label="item.SUPTYNM" :value="item.IDSEQ"></el-option>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-option  :label="item.SUPNM" :value="item.IDSEQ"></el-option>
                                        </el-col>
                                    </el-row>
                                </el-select>
                                <el-select size="medium" filterable v-else-if="item.key==='STAFFNM'" :disabled="saveFlag" style="width:100%" v-model="mainRow[item.FLDNO]">
                                    <el-row v-for="item in empArr " :key="item.IDNO">
                                        <el-col :span="6">
                                            <el-option  :label="item.IDNO" :value="item.EMPNM"></el-option>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-option  :label="item.DEPTNM" :value="item.EMPNM"></el-option>
                                        </el-col>
                                        <el-col :span="7">
                                            <el-option  :label="item.EMPNM" :value="item.EMPNM"></el-option>
                                        </el-col>
                                    </el-row>
                                </el-select>
                                <el-input size="medium" :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="mainRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </span>
                <div class="one-toolbar">
                    <span class="spanRow"> {{ $LANG('1005', '采购明细') }}</span>
                </div>
                <el-table  :data="dtlData" 
                    border                            
                    size="small"
                    style="margin-top:-8px"
                    class="custom-table-border"
                    :cell-style="{padding:'2px'}"
                    ref="refdtl"
                    show-summary
                    :summary-method="getSummary"
                    :height="400" 
                    highlight-current-row
                    @row-click="perClick" > 
                    <el-table-column :label="$LANG('0310', '序号')" width="55" type="index"></el-table-column>
                    <el-table-column  v-for="(item ,index) in perCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.key!=='RN' &&item.edcss!=='checkbox' &&item.sortable=='N'"
                        :min-width="item.width">
                        <template slot-scope="scope">
                            <el-checkbox v-if="item.edcss=='checkbox'" disabled  true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            <span v-else v-text="scope.row[item.key]"></span>
                        </template> 
                    </el-table-column> 
 
                </el-table>
                <div class="one-toolbar"  >
                    <div class="spanRow" style="display:flex;  ">{{ $LANG('1026', '附件明细') }}</div>
                </div>
                <div style="display:flex;margin-left:10px;" >
                    <span v-for="(item,index) in imgData" :key="index">
                        <div v-if="item.FILEPATH &&item.FILEPATH.lastIndexOf('.pdf')>-1" style="width:150px;height:125px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div>
                        <el-image v-else :preview-src-list="[item.FILEPATH]" fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.FILEPATH">
                            <div   slot="error" style="color:red;font-weight:600">文件名：{{item['FILENM']}}</div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                            <el-link v-if="item.FILEPATH.lastIndexOf('.pdf')>-1" :underline="false" @click="pdfViewer(item.FILEPATH)"><Icon type="ios-search" /> {{ $LANG('0141', '预览') }}</el-link>
                        </div>
                    </span>
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="drawer=false" size="small"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">{{ $LANG('1638', '确定') }}</el-button>
            </span>
        </el-dialog>
        <!-- 审批意见 -->
        <el-dialog v-dialogDrag :visible.sync="cfmWin" width="600px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1220', '回复日期内容') }}</span>
            </div> 
            <div style="font-size:11px;line-heigth:30px">{{ $LANG('1349', '预计交货日期') }}：</div>
            <el-date-picker type="date"  :clearable="false" v-model="v_dttm" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>
            <div style="font-size:11px;line-heigth:30px">{{ $LANG('0535', '交货备注') }}：</div>
            <el-input  type="textarea" :rows="7"  v-model="v_rmk"></el-input>
            <span slot="footer"  >
                <el-button type="info" @click="cfmWin=false" size="small"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
                <el-button @click="cfmSure" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > {{ $LANG('1638', '确定') }} </el-button>
            </span>
 
            <div style="line-height:30px;border-bottom:2px solid #389;margin-top:5px;background:white"><i class="iconfont icon-xinxi" style="margin-right:4px"></i>{{ $LANG('0235', '上传已盖单的采购合同(可以是图片或PDF格式）') }}</div>
            <div style="display:flex" >
                <Upload
                    ref="upload"
                    name="upfile"
                    :data="uploadData"
                    :show-upload-list="false"
                    :before-upload="beforeImgFile"
                    :on-success="successImgFile"
                    :on-progress="handleProgress"
                    :with-credentials="true"                            
                    :format="['jpg','jpeg','png','gif','pdf']"
                    :max-size="4096"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    v-if="!FILEPATH "
                    type="drag"
                    :action="uploadUrl"
                    style="display: inline-block;width:200px; ">                           
                    <div   style="padding: 1px 0;width:200px;height:190px;">
                        <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                        <p style="color:#515a6e;margin-top:5px;">{{ $LANG('1842', '将文件拖动此处或点击上传') }}</p>
                    </div>                                                       
                </Upload> 
                <div style="display:flex;margin-left:30px;min-height:200px;flex-wrap:wrap"  >
                    <div v-if="FILEPATH" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH &&FILEPATH.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div>
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH]" style="width:200px;height:150px;" :src="FILEPATH">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">{{ $LANG('1025', '附件名称') }}：{{FILEPATH}}</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link  :underline="false" @click="imgDel(0)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                            <el-link v-if="FILEPATH.lastIndexOf('pdf')>-1" :underline="false" @click="imgPreview( FILEPATH)"><Icon type="ios-search" /> PDF{{ $LANG('0141', '预览') }}</el-link>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 下推窗口 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="nextWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:30px; font-size:14px;padding-left:5px;">{{ $LANG('1047', '下推送货单') }}</span>
            </div>
            <div style="height:40px;line-height:30px;border-bottom:2px solid #389;padding-bottom:4px; ">
                <el-checkbox :label="$LANG('0263', '全选')" v-model="v_selAll" @change="selRec" true-label="Y" false-label="N"></el-checkbox>
                 {{ $LANG('0298', '字段') }}
                <el-select v-model="selparam3"  :placeholder="$LANG('1675', '请选择列名')" filterable  size="small" style="width:130px; margin-left:4px">
                    <span v-for="item in stkCol" :key='item.key' >
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input clearable  :placeholder="input_hold" v-model="txtparam3" @keyup.enter.native="nextSet" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper3" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="nextSet" ></el-button>
                </el-input>
                <el-checkbox true-label="Y" false-label="N" v-model="isSame" style="line-height:30px;margin-left:15px;margin-right:4px; "><span style="font-size:11px">{{ $LANG('1172', '与采购数相同') }}</span></el-checkbox>
                <el-button type="danger" @click="alloCate" size="small" icon="iconfont icon-shipeiqi" style="width:110px;margin-left:10px;height:35px;margin-top:2px;line-height:15px;color:white">{{ $LANG('0523', '下推记录') }}</el-button>
            </div>
            <div style="height:86vh;overflow-y:auto;  ">
                <el-table  :data="nextData.filter(item=>item.ISNEXT=='N')" 
                    border                            
                    size="small"
                    ref="refnext"
                    v-loading="t_loading"
                    :element-loading-text="$LANG('1959', '加载中')"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    class="custom-table-border"
                    cell-class-name="clearPadding"
                    :cell-style="{padding:'2px'}"
                    :height="400"  
                    highlight-current-row >   
                    <el-table-column :label="$LANG('0310', '序号')" type="index" width="65"></el-table-column>
                    <el-table-column  v-for="(item ) in stkCol.filter(item=>item.thide=='N')" :key="item.key"
                        :prop="item.key"
                        :label="item.title"
              
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.edcss!=='checkbox'&&item.key!=='RN'"
                        :min-width="item.width">
                        <template  slot-scope="scope" >
                            <el-checkbox @change="chkChg(scope.row)" v-if="item.edcss=='checkbox'" true-label="Y" false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            <el-input-number v-else-if="item.key=='SHPQTY'" :id="scope.$index+scope.column.property"   
                                    size="mini" style="width:100%" controls-position="right" 
                                     v-model="scope.row[item.key]"></el-input-number>
                            <el-input v-else-if="item.key=='SENDRMK'" :id="scope.$index+scope.column.property"   
                                    size="mini" style="width:100%" controls-position="right" 
                                     v-model="scope.row[item.key]"></el-input>                                     
                            <span v-else  >{{scope.row[item.key]}}</span>
                        </template>
                    </el-table-column>     
                </el-table>
                <el-table  :data="sendData" 
                    border                            
                    size="small"
                    ref="refsend"
                    class="custom-table-border"
                    :cell-style="{padding:'2px'}"
                    :height="maxHeight" 
                    highlight-current-row > 
                    <el-table-column :label="$LANG('0310', '序号')" type="index" width="65"></el-table-column>
                    <el-table-column v-for="(item ) in stkCol.filter(item=>item.thide=='N'&&item.key!=='SEL')" :key="item.key"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.edcss!=='checkbox'"
                        :min-width="item.width">
                        <template  slot-scope="scope" >
                            <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"   false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            <div v-else  >{{scope.row[item.key]}}</div>
                        </template>
                    </el-table-column> 
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="75">
                        <template slot-scope="scope">
                            <el-button size="mini" :disabled="saveFlag"  type="text" icon="el-icon-close" @click="nextDel(scope.row,scope.$index)">{{ $LANG('0131', '删除') }}</el-button>
                        </template>
                    </el-table-column>
                </el-table>    
            </div>  
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button  type="info" @click="nextWin=false" size="mini"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
                    <el-button style="margin-left:30px" type="primary" @click="genSend" size="mini"  icon="iconfont icon-chenggong1"> {{ $LANG('1119', '生成送货单') }}</el-button>
                </span>
            </div>         
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">{{ $LANG('2052', '正在上传中') }}...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
    </div>  
</template>
<script>
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate, getDate2 } from '../../api/Select' 
import FileSaver from 'file-saver'
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import {
    buildVeTableHeaderCondition,
    escapeVeTableQueryValue,
    isVeTableMetadataField,
} from '@/utils/veTableHeaderQuery'
//局部注册
export default {
    name:"supply_ordcfm",
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '397191',
            fieldIdseq: '397191',
            fieldLstseq: '1',
            mainColumnKey: 'tabArr',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tabref',
            columnHiddenOptionKey: 'columnHiddenOption',
            fixedFieldKeys: ['SEL'],
            generatedFixedColumnKeys: ['rownum', 'oper'],
        })
    ],
    data () {
        return {
            imgData:[],

            sendData:[],
            isSame:'Y',
            stkCol:[],
            nextData:[],
            v_selAll:'N',
            v_select:'N',
            nextWin:false,
            repUrl:'',
            repWin:false,
            v_dttm:'',
            v_rmk:'',
            cfmWin:false,
            pageList: [{
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
                } ],
            input_hold:this.$LANG('1718', '请输入查询的值'),
            supArr:[],
            drawer:false,
            matWin:false,
            saleWin:false,
            perFlag:'create',
            dtlRow:{},
            sendVal:'PRD',
            saveFlag:false,
            empWin:false,
            promptWin:false,
            prodWin:false,
            prompt:'',
            stfgCss:'',
            v_row:{},
            stfgColor:'',
            mainRow:{},
            v_rowIndex:'',
            cashArr:[], // 
            listIndex:'-1',
            active:'', //二级菜单选中标志

            t_loading:false,
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            formArr:[],
            tabData:[], //表数据
            allData:[],
            tabArr:[], //表列
            initCol:[],
            vueCol:[],
            columnHiddenOption: { defaultHiddenColumnKeys: [] },
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            queryRequestId:0,
            headerSortKey:'',
            headerSortOrder:'',
            virtualScrollOption: { enable: false },
            eventCustomOption: {
                bodyRowEvents: ({ row }) => ({ click: () => this.rowClick(row) }),
            },
            dtlData:[], //明细数据
            perCol:[],
            operArr:[],
            oper:'like',
            oper2:'like',
            comboArr:{},
            txtparam:'',
            selparam:'ORDDTTM',
            v_inputrow:{},
            txtparam3:'',
            selparam3:'IDNO',
            oper3:'like',
            delArr:[],
            empArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            dataCount:0,
            rowSize:50,
            goPage:'',
            notNull:[],
            current:1,
            stfg_:'N',
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            stfgArr:[],
            v_loading:false,
            v_seq:'',
            maxHeight:'',
            uploadData:{},
            fileName:'',
            FILEPATH:'',
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            Accept: "png,jpg,jpeg,gif,pdf", //上传文件格式限制
            videoUploadPercent:0,
            videoFlag:false,
            v_oth:'N',
            v_nasPath:'',
        }
    },
    mounted () {
        this.maxHeight = document.documentElement.clientHeight - 560 
        //用户表单新增、编辑、审核、作废权限 :frmid:  ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','397191','v_sys_user_priv',' and issel=\'Y\'').then(res=>{             
            let row =res.result[0]
            this.v_oth =row['ISOTH']
            this.getOrdList(' and orddttm>=\''+getDate2(30)+'\'')
            if (row.ISADD==='N'){ //新增
                this.addBool=true
            }if (row.ISUPD==='N'){ //修改
                this.editBool=true
            }if (row.ISDEL==='N'){ //删除
                this.delBool=true
            }if (row.ISCFM==='N'){ //审核
                this.cfmBool=true
            }if (row.ISCANCEL==='N'){ //作废
                this.cancelBool=true
            }
       
        })  
        //操作符
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });
 
        //表单所以下拦框动态赋值
        this.comSelect()
        //供应商
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','v_bs_sup','').then(res=>{
            this.supArr =res.result
        })
        //人员资料
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','v_hr_emp','').then(res=>{
            this.empArr =res.result
        })
        //资金账户选择
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'accty','14410','v_ac_account',' and stfg=\'Y\'').then(res=>{
            this.cashArr =res.result
        })
 
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','397191','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formArr = res.result             
            }else{
                this.promptWin=true
                this.prompt=res.result
            }
        })
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','397191','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =this.$translate.getColTitle(item, this.$store.state.lang)
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空')}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    computed: {
        editHeight: function() {
            return (window.innerHeight - 400) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 162) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        }, 
    },
    components: {
        VeColumnConfigDialog,
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            
            this.getTabField() //表列字段
    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        sortHeaderColumn(column, edcss){
            const key =column.key
            if (!key) return
            if (this.headerSortKey === key) {
                this.headerSortOrder =this.headerSortOrder === 'asc' ? 'desc' : 'asc'
            }else{
                this.headerSortKey =key
                this.headerSortOrder ='asc'
            }
            const direction =this.headerSortOrder === 'asc' ? 1 : -1
            const type =String(edcss || '').toLowerCase()
            this.tabData.sort((left, right) => {
                const leftValue =left[key]
                const rightValue =right[key]
                if (leftValue === rightValue) return 0
                if (leftValue === null || leftValue === undefined || leftValue === '') return 1
                if (rightValue === null || rightValue === undefined || rightValue === '') return -1
                if (type === 'number') return (Number(leftValue) - Number(rightValue)) * direction
                if (type === 'date' || type === 'date2' || type === 'time') {
                    return (new Date(leftValue).getTime() - new Date(rightValue).getTime()) * direction
                }
                return String(leftValue).localeCompare(String(rightValue), undefined, { numeric: true }) * direction
            })
        },
        pdfViewer(path){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl: path},
            });
            window.open(routeUrl.href, '_blank');
        },
        selChg(){
            this.tabData.forEach(item=>{
                item.SEL =this.v_select
            })
        },
        downFile(){
            let item='/assets/authorize/采购合同执行条款.docx'
            let blob =new Blob([item],{type:'text/plain;charset=utf-8'})
            const arr_name=item.split("/")
            const file_name=arr_name[arr_name.length-1] //获取文件名
            FileSaver.saveAs(item,file_name) 
        },
        rowShow(){
            this.selparam =''
            this.txtparam =''
            this.oper ='like'
            this.v_inputrow ={}
            this.current =1
            this.qryTabData()
        } ,
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='AMT' ){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        //图片预览
        imgPreview(path){
            if (path &&path.lastIndexOf('.pdf')>-1){
                let routeUrl = this.$router.resolve({
                    path: '/fullPreview',
                    query: {fileUrl: path},
                });
                window.open(routeUrl.href, '_blank');
            } 
        },
 
        //图片删除，操作数组
        imgDel( index){
            this.$confirm(this.$LANG('1594', '你确定要删除此附件吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                if (index==0){
                    if (this.FILEPATH.indexOf('https://')>-1 && this.FILEPATH  ){
                        this.$axios({
                            method: 'post',
                            url: '/xuper_oss/ftpDelete',
                            data: {p_path:'/volume1'+this.v_nasPath},
                        }).then(res=>{
                            this.FILEPATH =''
                        })
                    }
                }                                    
            }).catch(()=>{})
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        handleFormatError (file) {
            this.promptWin =true
            this.prompt=this.$LANG('1455', '文件格式错误,')+file.name + this.$LANG('1431', ' 是不正确, 请选择图片或PDF格式')
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + this.$LANG('1561', '文件太大， 不能超出') + '4M'
        },
 
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            let v_filename= this.$store.state.nasUrl+res.result
            
            if (!this.FILEPATH ){
                this.FILEPATH =v_filename
                this.v_nasPath='/web/web_images/material/'+res.result
            } 
        },
        beforeImgFile (res, file) {
            this.fileName= this.v_username+getDate('year')
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise;
        },
        nextDel(row,index){
            this.nextData.push(JSON.parse(JSON.stringify( Object.assign(row,{ISNEXT:'N',SEL:'N'}))))
            this.sendData.splice(index,1)          
        },
        //分配
        alloCate(){
            let v_bool =false
            this.nextData.some(item=>{
                if (item['SEL']=='Y'){
                    v_bool =true
                }
            })
            if (!v_bool ){
                this.promptWin =true
                this.prompt =this.$LANG('1684', '请选择记录')
            }else{
                let v_supnm =''
                this.nextData.forEach((item,index)=>{
                    if (item.SEL=='Y'){
                        item['ISNEXT']='Y'
                        this.nextData.splice(index,1,JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'Y',SEL:'N'}))))
                        this.sendData.push(JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'N','SEL':'N'}) )))
                    }
                })
            }  
        },
        //查询下推明细
        nextSet(){
            this.v_selAll='N'
            this.nextData=[]
            let cond_=''
            if (this.selparam3){ //列1
                if (this.oper3==='like'){
                    cond_=cond_+' and  '+this.selparam3+'  like  \'%' + this.txtparam3+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam3 +this.oper3+' \''+this.txtparam3+'\' '
                }
            }
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond_+'  and idseq in ('+this.v_seq+') order by '+this.selparam3,p_table:'V_po_orddtl'},
            }).then(res=>{ 
                this.nextData =res.result
            })    
        },
        stfgRec(row, index){
            this.$confirm(this.$LANG('1585', '你要反确认此单据吗?'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                vm.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value: row['IDSEQ'], p_table:'PO_ORD',p_cond:' set ischk=\'N\',Cfmdttm= null'+',Replydttm= null' +' ,CFMrmk= null' },
                }).then(res=>{ 
                    vm.tabData.splice(index,1,Object.assign(row,{'ISCHK':'N','CFMDTTM':'','REPLYDTTM':'','CFMRMK':''}))
                })
            }).catch(()=>{})            
        },
        chkChg(row){
            if (!row['SHPQTY'] && row['SEL']=='Y'){
                row['SHPQTY'] =row['QTY']
            }
        },
        //下推生成送货通知
        genSend(){
            let v_arr =this.sendData
            if (v_arr.length ==0){
                this.promptWin =true
                this.prompt =this.$LANG('1641', '下推记录为空')
            }else{
                this.$confirm(this.$LANG('1609', '你确定要生成采购送货单吗'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    let v_json =JSON.stringify(v_arr)
                    let v_action =this.v_username+getDate('full')
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/next_gensent',
                        data: { corpid:this.v_corpid,p_json: v_json,p_user: this.v_username,p_action:v_action},
                    }).then(res=>{ 
                        if (res.code=='200'){        
                            this.$notify({
                                title: this.$LANG('1441', '成功'),
                                message: this.$LANG('1488', '已成功下推送货单，请到采购送货单界面中查看'),
                                type: 'success'
                            })
                        }else{
                            this.promptWin =true
                            this.prompt =this.$LANG('1446', '下推失败！')+res.result
                        }
                        this.nextWin =false
                    })
                }).catch(err=>{})
            }
        },
        selRec(){          
            this.nextData.forEach((item,index)=>{
                let v_qty =this.v_selAll =='Y'?item['QTY']:''
                this.nextData.splice(index,1,JSON.parse(JSON.stringify(Object.assign(item,{SEL:this.v_selAll,SHPQTY:v_qty})) ))
            })          
        },
        nextGen(){
            this.v_seq =''
            this.sendData=[]
            this.tabData.forEach(item=>{
                if (item['SEL']=='Y'){
                    if (this.v_seq ){
                        this.v_seq =this.v_seq+',\''+item['IDSEQ']+'\''
                    }else{
                        this.v_seq ='\''+item['IDSEQ']+'\''
                    }
                }
            })
            if (!this.v_seq){
                this.promptWin =true
                this.prompt =this.$LANG('1758', '请选择采购单记录')
            }else{
                this.v_selAll='N'
                this.nextWin =true
                this.getNextData(this.v_seq) 
            }
        },
        getNextData(idseq){
            this.nextData=[]
            this.t_loading=true
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'corpid',p_value:this.v_corpid,p_cond:' and idseq in ('+idseq+')'+' order by '+this.selparam3, p_table:'v_po_orddtl'},
            }).then(res=>{ 
                this.nextData =res.result   
                this.t_loading=false        
            })          
        },
        repShow(row){
            this.repWin =true
            //this.v_oth=='Y'
            if (this.v_corpid=='300'){
                this.repUrl =this.$store.state.repUrl+ 'rep_poord2.cpt'+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }else{
                this.repUrl =this.$store.state.repUrl+ 'rep_poord.cpt'+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] +'&p_oth='+this.v_oth
            }
        },
        //状态变更确认
        stfgSure(row,v_index,val,stfg){
            let v_val = (val=='Y'?this.$LANG('0364', '确认'):this.$LANG('0445', '反确认') )
            let v_comm=this.$LANG('1579', '你确定要变更状态为：')+v_val +' '+this.$LANG('0836', '吗')+'？'
            let v_stfg =stfg=='17426'?this.$LANG('2040', '已确认未送货'):this.$LANG('2035', '已发出未确认')
            this.$confirm(v_comm,this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value: row['IDSEQ'],p_table:'po_ord',p_cond:' set stfg=\''+ stfg +'\'' },
                }).then(res=>{  
                    this.tabData.splice(v_index,1,Object.assign( row,{STFGNM:v_stfg,STFG: stfg }))                 
                })
            }).catch(()=>{})
            
        },
        qtyPrc(){
            let tax_=!this.dtlRow['TAX']?0:this.dtlRow['TAX']; 
            let qty_=!this.dtlRow['QTY']?0:this.dtlRow['QTY']; 
            if( this.dtlRow['TAXPRC']){
                this.dtlRow['PRC']=Number(this.dtlRow['TAXPRC'])/ (Number(tax_)+100) *100 
                this.dtlRow['TAXAMT']=Number(this.dtlRow['TAXPRC'])*Number((tax_) /100) *Number(qty_)
                this.dtlRow['AMT']=Number(qty_)*Number(this.dtlRow['TAXPRC']) 
            }else{
                this.dtlRow['AMT']=0
                this.dtlRow['TAXAMT']=''
                this.dtlRow['PRC']=''
            }
        },
 
        //表行点击事件
        rowClick(row){
 
            // this.getDtlData(row.IDSEQ)
        },
 
        perClick(row){
            
        },
  
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'397191',p_key2:'lstseq',p_value2:'1',p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.$set(this.comboArr, res.result[k].FLDNO, res2.result)
                        })
                    }
                }
            })  
        },
 
        //状态审核
        recSet(row,val){
            let stfg_ =val==='Y'?this.$LANG('0134', '审核'):this.$LANG('0142', '反审核')
            this.$confirm(this.$LANG('1564', '你确定要')+stfg_+this.$LANG('1566', '此行记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'po_ord',p_cond:' set stfg=\''+val+'\'' },
                }).then(res=>{      
                    if(res.code =='200')  {           
                        vm.qryTabData()     
                    }else{
                        this.promptWin=true
                        this.prompt=res.message
                    }        
                }) 
                 
            }).catch(()=>{})
        },
        //订单明细
        getOrdList(cond){
            //获取所有产品记录且初始化分页记录   
            let v_cond =cond
            if (this.stfg_!=='ALL'){
                v_cond =v_cond +' and ISCHK=\''+this.stfg_+'\''
            }
            if ( this.v_oth=='Y' ){ //仅能看自己记录时
               v_cond =v_cond +' and paysrc!=\'433336\' and supno in (select empidseq from v_sys_user where userno=\''+this.v_username+'\')'
            } 
            this.v_loading =true
            const requestId =++this.queryRequestId
            const orderKey =this.initCol.some(item => item.key === this.selparam) ? this.selparam : 'ORDDTTM'
            this.$axios({   //过滤终止和 西雅斯代付的订单
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'POTY', p_value:'PRD',p_key2:'corpid', p_value2:this.v_corpid,p_cond:v_cond+' and stfg in (\'K2\',\'Y\') and ordstfg!=\'END\' order by '+orderKey+' desc',p_table:'V_po_ord'},
            }).then(res=>{ 
                if (requestId !== this.queryRequestId) return
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        const table = this.$refs.tabref
                        if (table && typeof table.doLayout === 'function') table.doLayout()
                    })
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
            }).catch(error=>{
                if (requestId !== this.queryRequestId) return
                this.promptWin=true
                this.prompt=error.message || this.$LANG('1641', '查询失败')
            }).finally(()=>{
                if (requestId === this.queryRequestId) this.v_loading=false
            }) 
        },
        //查询明细数据
        getDtlData(idseq){
            getTabColOrData(this.v_url,'V_po_orddtl','idseq',idseq).then((res) => {
                this.dtlData=[]
                this.dtlData =res.result  
                this.$nextTick(()=>{
                    this.$refs['refdtl'].doLayout()
                })
                
            })
        },
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promptWin=true
                this.prompt=this.$LANG('1721', '请输入跳至页数')
            }
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
               
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            this.$nextTick(() => {
                const table =this.$refs.tabref
                if (table && typeof table.doLayout === 'function') table.doLayout()
            })
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current=index
            this.tabData = this.allData.slice(_start,_end);
        },
        cfmSure(){
            if (!this.v_dttm ) {
                this.promptWin =true
                this.prompt =this.$LANG('1349', '预计交货日期')+this.$LANG('2051', '不能为空')
            }else if (!this.FILEPATH &&  this.v_oth=='Y' ) {
                this.promptWin =true
                this.prompt =this.$LANG('0819', '请上传已盖章的采购合同附件')
            }else{
                let vm =this
                this.$confirm(this.$LANG('1625', '确认前请先查看详细内容，要确认吗'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    let cond_ =' set ischk=\'Y\',Cfmdttm=\''+getDate('full')+'\',Replydttm=\''+this.v_dttm+'\',CFMrmk=\''+this.v_rmk+'\',imgpath=\''+this.FILEPATH+'\',NASPATH=\''+this.v_nasPath+'\''
                    vm.$axios({
                        method: 'post',
                        url:'xuper_auth/updateRec',
                        data: {p_key:'idseq',p_value:vm.v_row['IDSEQ'], p_table:'PO_ORD',p_cond:cond_},
                    }).then(res=>{ 
                        if (res.code=='200'){
                            vm.cfmWin =false
                            vm.tabData.splice(vm.v_rowIndex,1,Object.assign(vm.v_row,{'ISCHK':'Y','CFMDTTM':getDate('full'),'REPLYDTTM':vm.v_dttm,'CFMRMK':vm.v_rmk,'IMGPATH':this.FILEPATH}))
                        }else{
                            vm.promptWin =true
                            vm.prompt =res.result
                        }
                    })
                }).catch(()=>{})
            } 
        },
        qryImgData(idseq){
            getTabColOrData(this.v_url, 'V_mat_img','idseq',idseq,'','').then((res) => {
                this.imgData=[]
                if (res){
                    this.imgData =res.result
                }
            })
        },
        editRec(row,val,index){
            this.v_rowIndex =index
            if (val==='Y'){  //仅查看
                this.saveFlag=true
                this.mainRow =JSON.parse(JSON.stringify(row))
                this.drawer=true   
                this.getDtlData(row.IDSEQ)
                this.qryImgData(row.IDSEQ)
            }else if (val=='C'){
                this.cfmWin =true
                this.v_dttm =getDate()
                this.v_row =JSON.parse(JSON.stringify(row))
                this.v_rmk =''
                this.FILEPATH =row['IMGPATH']
                this.v_nasPath=row['NASPATH']
                if (row['REPLYDTTM']){
                    this.v_dttm =row['REPLYDTTM']
                } if (row['CFMRMK']){
                    this.v_rmk =row['CFMRMK']
                }    
            }      
        },
        getRowKey(row){
            return row.IDSEQ
        },
        //查询
        qryTabData(){
            let toolbarCondition =''
            const toolbarOperators =['like', '=', '>', '<', '>=', '<=', '!=']
            if (isVeTableMetadataField(this.initCol, this.selparam) && toolbarOperators.includes(this.oper)) {
                const value =escapeVeTableQueryValue(this.txtparam || '')
                toolbarCondition =this.oper === 'like'
                    ? ` and ${this.selparam} like '%${value}%'`
                    : ` and ${this.selparam}${this.oper}'${value}'`
            }
            const headerCondition =buildVeTableHeaderCondition(this.initCol, this.v_inputrow, {
                numberOperatorDefault: '>=',
            })
            this.current =1
            this.headerSortKey =''
            this.headerSortOrder =''
            this.getOrdList(toolbarCondition+headerCondition)
        },
        //新增 
        addRec(){
            this.drawer =true
            this.stfgCss='icon-weishenhe3'
            this.mainRow={ORDDTTM:getDate('day'),STFG:'17423'}
            this.saveFlag=false
            this.dtlData=[]
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','397191','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                vm.initCol = res.result || []
                return vm.loadInitialFieldSettings().then(() => {
                    const isSelectionField =item => String(item && (item.key || item.FLDNO) || '').toUpperCase() === 'SEL'
                    const sortedBusinessFields =vm.sortFieldRows(vm.initCol.filter(item => !isSelectionField(item)))
                    let businessFieldIndex =0
                    const fieldRows =vm.initCol.map(item => (
                        isSelectionField(item) ? item : sortedBusinessFields[businessFieldIndex++]
                    ))
                    vm.tabArr = []
                    vm.vueCol = []
                    fieldRows.forEach(item => {
                        const title = vm.$translate.getColTitle(item, vm.$store.state.lang)
                        vm.tabArr.push({
                            title,
                            key: item.key,
                            align: item.align,
                            width: item.width,
                            thide: item.THIDE,
                            fhide: item.FHIDE,
                            edcss: item.EDCSS,
                            disabled: item.DISABLED,
                            dotnum: item.DOTNUM,
                            sortable: item.SORTABLE,
                        })
                        if (item.THIDE !== 'N' && item.key !== 'SEL') return
                        vm.vueCol.push({
                            field: item.key,
                            key: item.key,
                            title,
                            align: item.align,
                            width: Number(item.width) || 120,
                            sortable: false,
                            ellipsis: { showTitle: true },
                            renderHeaderCell: ({column}) => {
                                if (item.key === 'SEL') return <div class="suppo-ord-select-header">
                                    <div class="suppo-ord-select-header__title">{column.title}</div>
                                    <el-checkbox size="mini" true-label="Y" false-label="N" v-model={this.v_select} on-change={() => this.selChg()}></el-checkbox>
                                </div>
                                const stfgOptions =item.key === 'STFG' ? [
                                    { value: 'Y', label: this.$LANG('1976', '已审核') },
                                    { value: 'N', label: this.$LANG('2005', '未审核') },
                                    { value: 'P', label: this.$LANG('1961', '审核中') },
                                    { value: 'K', label: this.$LANG('1970', '已发起') },
                                ] : []
                                const metadataOptions =(this.comboArr[item.FLDNO] || []).map(option => ({
                                    value: option.CODE,
                                    label: this.$translate.getColTitle(option, this.$store.state.lang),
                                }))
                                const options =stfgOptions.length ? stfgOptions : metadataOptions
                                const sortable =item.key !== 'RN' && item.SORTABLE === 'N' && item.EDCSS !== 'checkbox'
                                return <VeTableQueryHeader
                                    title={column.title}
                                    edcss={item.key === 'STFG' ? 'select' : item.EDCSS}
                                    value={this.v_inputrow[item.key]}
                                    operator={this.v_inputrow[`#OPER${item.key}`]}
                                    defaultOperator=">="
                                    showDateOperator={false}
                                    sortable={sortable}
                                    sortOrder={this.headerSortKey === item.key ? this.headerSortOrder : ''}
                                    options={options}
                                    on-input={(value) => this.$set(this.v_inputrow, item.key, value)}
                                    on-operator-change={(value) => this.$set(this.v_inputrow, `#OPER${item.key}`, value)}
                                    on-title-click={() => {
                                        if (sortable) this.sortHeaderColumn(column, item.EDCSS)
                                    }}
                                    on-query={this.qryTabData}
                                />
                            },
                            renderBodyCell: ({row}) => {
                                const value = row[item.key]
                                if (item.key === 'IDNO') return <el-link underline={false} on-click={() => this.repShow(row)}><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:12px">{value}</div></el-link>
                                if (item.key === 'STFG') {
                                    if (value === 'Y') return <el-tag size="mini" type="success" effect="dark">{this.$LANG('1976', '已审核')}</el-tag>
                                    if (value === 'N') return <el-tag size="mini" type="info" effect="dark">{this.$LANG('2005', '未审核')}</el-tag>
                                    if (value === 'P') return <el-tag size="mini" type="danger" effect="dark">{this.$LANG('1961', '审核中')}</el-tag>
                                    if (value === 'K') return <el-tag size="mini" type="warning" effect="dark">{this.$LANG('1970', '已发起')}</el-tag>
                                    return <span>{value}</span>
                                }
                                if (item.key === 'ISCHK') return value === 'Y' ? <el-tag size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> : value === 'N' ? <el-tag size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> : <span>{value}</span>
                                if (item.key === 'SEL') return <el-checkbox true-label="Y" false-label="N" v-model={row[item.key]}></el-checkbox>
                                if (item.key === 'IMGPATH') {
                                    const isPdf =value && String(value).toLowerCase().lastIndexOf('.pdf') > -1
                                    return <el-link underline={false}>
                                        {isPdf
                                            ? <div on-click={() => this.imgPreview(value)}><i class="iconfont icon-pdf"></i></div>
                                            : <el-image style="width:100%;height:20px" src={value} preview-src-list={[value]}><div slot="error"><i class="el-icon-picture-outline"></i></div></el-image>}
                                    </el-link>
                                }
                                return <div style="float:left">{value}</div>
                            },
                        })
                    })
                    vm.vueCol.unshift({
                        field: 'index',
                        key: 'rownum',
                        title: vm.$LANG('0310', '序号'),
                        width: 60,
                        align: 'center',
                        fixed: 'left',
                        renderHeaderCell: () => <el-link underline={false} on-click={() => this.rowShow()} style="font-size:12px;color:#404eff"><el-tooltip content={this.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link>,
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                    })
                    vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0330', '操作'),
                        width: 130,
                        align: 'center',
                        fixed: 'right',
                        renderBodyCell: ({row, rowIndex}) => (
                            <div>
                                <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                                <el-link on-click={() => this.editRec(row, 'Y', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                {row.ISCHK !== 'Y' ? <span><i class="iconfont icon-chenggong" style="color:#409EFF;font-size:12px;margin-right:3px"></i><el-link disabled={row.STFG !== 'Y'} on-click={() => this.editRec(row, 'C', rowIndex)} underline={false}><span style="font-size:12px;margin-right:3px">{this.$LANG('0364', '确认')}</span></el-link></span> : <span><i class="iconfont icon-chucuo" style="color:#409EFF;font-size:12px;margin-right:3px"></i><el-link disabled={row.STFG !== 'Y'} on-click={() => this.stfgRec(row, rowIndex)} underline={false}><span style="font-size:12px;margin-right:3px">{this.$LANG('0314', '弃认')}</span></el-link></span>}
                            </div>
                        ),
                    })
                    vm.applyFieldSettingRows()
                    return res
                })
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','397191','lstseq','2','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.perCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','397191','lstseq','4','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.stkCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .suppo-ord-page {
        background: white;
    }
    .suppo-ord-toolbar {
        display: flex;
        width: 100%;
        min-width: 1300px;
        padding-top: 3px;
        background: #fff;
        line-height: 30px;
        border-bottom: 2px solid #389;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
 
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        color:#409EFF;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    #suppo_ord_table .ve-table-content-wrapper {
        min-height: 100%;
    }
    #suppo_ord_table .table-head-cell-class {
        padding: 0 !important;
        padding-top: 4px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        border-width: 1px !important;
        border-color: #808695 !important;
        font-size: 12px !important;
        font-weight: 700 !important;
        text-align: center !important;
    }
    #suppo_ord_table .table-body-cell-class1 {
        height: 20px !important;
        padding: 2px !important;
        color: black !important;
        border-width: 1px !important;
        border-color: #808695 !important;
        font-size: 12px !important;
    }
    #suppo_ord_table .suppo-ord-select-header {
        text-align: center;
    }
    #suppo_ord_table .suppo-ord-select-header__title {
        margin-top: 3px;
        color: #03274b;
        font-size: 12px;
        font-weight: 700;
        text-align: center;
        white-space: nowrap;
    }
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
